import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, BadgeCheck } from "lucide-react";

export const Seal = ({ className = "w-32 h-32" }) => (
  <div className={`relative shrink-0 ${className}`} aria-hidden="true">
    <svg viewBox="0 0 120 120" className="absolute inset-0 w-full h-full animate-[spin_28s_linear_infinite]">
      <defs><path id="gbtCirc" d="M60,60 m-47,0 a47,47 0 1,1 94,0 a47,47 0 1,1 -94,0" /></defs>
      <text className="f-mono" fontSize="8" letterSpacing="2.4" fill="#1B3B28">
        <textPath href="#gbtCirc">STUDIO CERTIFICATO GBT · ORIGINALE ·</textPath>
      </text>
    </svg>
    <div className="absolute inset-[22%] rounded-full bg-[#1B3B28] grid place-items-center text-center shadow-[0_0_0_6px_rgba(134,200,155,0.25)]">
      <span className="f-serif italic text-[#86C89B] text-xl leading-none">GBT<span className="block f-mono not-italic text-[7px] tracking-[0.2em] text-[#FCFBF7]/80 mt-1">ORIGINALE</span></span>
    </div>
  </div>
);

export const GbtBadge = () => (
  <section className="relative bg-[#F4F3EC] py-14 sm:py-16" data-testid="gbt-badge-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}>
        <Link to="/igiene-gbt" data-testid="gbt-badge-link"
          className="group flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-10 rounded-[2rem] bg-[#FCFBF7] border border-[#1B3B28]/10 p-6 sm:p-8 hover:border-[#3E6B48]/40 hover:shadow-[0_30px_60px_-35px_rgba(27,59,40,0.45)] transition-[box-shadow,border-color] duration-500">
          <Seal />
          <div className="flex-1">
            <p className="eyebrow text-[#3E6B48] flex items-center gap-2"><BadgeCheck size={14} /> Certificazione verificabile</p>
            <p className="f-serif text-3xl sm:text-4xl text-[#1B3B28] leading-[1.05] mt-3">Studio certificato GBT: <em className="text-[#3E6B48]">l'igiene professionale originale.</em></p>
            <p className="text-[#526356] mt-3 max-w-2xl">Guided Biofilm Therapy in 8 fasi, delicata anche per chi ha paura. Non tutti gli studi sono certificati: scopri come verificarlo.</p>
          </div>
          <span className="grid place-items-center w-14 h-14 shrink-0 rounded-full bg-[#1B3B28] text-[#FCFBF7] transition-transform duration-500 group-hover:rotate-45">
            <ArrowUpRight size={20} />
          </span>
        </Link>
      </motion.div>
    </div>
  </section>
);
